/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Box, IconButton } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const SCROLL_BY_PX = 300;
const CustomCarousel = (props) => {
  const elementRef = useRef(null);
  const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
  const [showArrows, setShowArrows] = useState(false);
  const [scrolledByCode, setScrolledByCode] = useState(false);

  const handleScrollRight = useCallback(() => {
    if (
      currentScrollPosition <
      elementRef.current.scrollWidth - elementRef.current.offsetWidth
    ) {
      setCurrentScrollPosition(currentScrollPosition + SCROLL_BY_PX);
    }
  }, [currentScrollPosition, setCurrentScrollPosition, elementRef]);

  const handleLeftArrowClick = useCallback(() => {
    if (currentScrollPosition > 0) {
      setCurrentScrollPosition(currentScrollPosition - SCROLL_BY_PX);
    }
  }, [currentScrollPosition, setCurrentScrollPosition]);

  const handleScrollLeft = useCallback(
    (event) => {
      if (scrolledByCode) {
        setScrolledByCode(false);
      } else {
        setCurrentScrollPosition(event.target.scrollLeft);
      }
    },
    [scrolledByCode, setCurrentScrollPosition]
  );

  useEffect(() => {
    if (
      elementRef?.current?.offsetWidth &&
      elementRef?.current?.scrollWidth &&
      elementRef?.current?.offsetWidth < elementRef?.current?.scrollWidth
    ) {
      setShowArrows(true);
    }
  }, [elementRef?.current]);

  useEffect(() => {
    if (elementRef.current) {
      elementRef.current.scroll(currentScrollPosition, 0);
      setScrolledByCode(true);
    }
  }, [currentScrollPosition]);

  return props?.elements?.length ? (
    <Box>
      <Box display="flex" alignItems="center">
        {showArrows ? (
          <IconButton
            aria-disabled={currentScrollPosition === 0}
            size="small"
            onClick={handleLeftArrowClick}
            aria-label={props?.ariaLabelLeftArrow}
            title="Slide left"
            disabled={!showArrows}
          >
            <KeyboardArrowLeftIcon sx={{ opacity: 1 }} />
          </IconButton>
        ) : null}
        <Box
          component="ul"
          role="list"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '99%',
            cursor: 'pointer',
            padding: 0,
            margin: 0,
          }}
          ref={elementRef}
          onScroll={handleScrollLeft}
        >
          {props?.elements?.map((element, index) => (
            <Box
              component="li"
              role="listitem"
              sx={{
                marginLeft: 0.5,
                marginRight: 0.5,
                display: 'inline-block',
                wordBreak: 'break-all',
                width: 'auto',
                listStyleType: 'none',
              }}
              // eslint-disable-next-line react/no-array-index-key
              key={`carousel_${index}`}
            >
              {element}
            </Box>
          ))}
        </Box>
        {showArrows ? (
          <IconButton
            aria-disabled={
              !(
                currentScrollPosition <
                elementRef.current.scrollWidth - elementRef.current.offsetWidth
              )
            }
            size="small"
            onClick={handleScrollRight}
            aria-label={props?.ariaLabelRightArrow}
            title="Slide right"
            disabled={!showArrows}
          >
            <KeyboardArrowRightIcon sx={{ opacity: 1 }} />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  ) : null;
};
export default CustomCarousel;
